import { createRouter, createWebHistory } from 'vue-router'
import Dashboard from '../views/Dashboard.vue'
import InboxConversationFallback from '../views/InboxConversationFallback.vue'

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/admin/inbox/conversation-panel',
    name: 'InboxConversationPanel',
    component: InboxConversationFallback
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
